import { createAPI } from "@/modules/api";
import type { PageContext } from 'vike/types'
import 'vike'

import { determineNavigationMode } from '@repo/ui'

import { createI18n } from 'vue-i18n';
import i18nConfig from '@/modules/i18n';

export async function onCreatePageContext(pageContext: PageContext) {
  pageContext.mode = determineNavigationMode(pageContext)

  // Create a new API instance for each request
  const api = createAPI({
    origin: pageContext.isClientSide ?
      import.meta.env.PUBLIC_ENV__API_ORIGIN : import.meta.env.PUBLIC_ENV__API_INTERNAL_ORIGIN,
    headers: {
      // Pass cookie for server-side API calls if available
      'Cookie': pageContext.isClientSide ? '' : pageContext.headers?.cookie ?? '',
      // Forward the visitor's IP (set by Cloudflare) so the gateway rate-limits per user, not per SSR server
      ...(!pageContext.isClientSide && pageContext.headers?.['cf-connecting-ip']
        ? { 'CF-Connecting-IP': pageContext.headers['cf-connecting-ip'] }
        : {})
    },
    params: {
      app: 'openroom_ja'
    }
  });
  // Make the API instance available to Vike hooks
  pageContext.api = api

  // Create a new i18n instance for each request
  const i18n = createI18n({
    ...i18nConfig,
    locale: pageContext.locale || i18nConfig.locale,
  })
  pageContext.i18n = i18n
}
